// src/shared/config/roles.js
// ─── TAXONOMIA DE PAPÉIS (RBAC) ───────────────────────────────────────────────
//   clinicAdmin  — administrador de UMA clínica. Escopo SEMPRE limitado ao seu
//                  estabelecimentoId (agendamentos, staff, procedimentos, janelas).
//   professional — prestador de serviço (vê a própria agenda).
//   client       — cliente final. É GLOBAL por design: pode agendar em qualquer
//                  clínica, logo seus dados não são isolados por estabelecimento.
//
// Super admin NÃO é um role: é EXCLUSIVAMENTE o e-mail SUPER_ADMIN_EMAIL,
// verificado no TOKEN de auth (ver AuthContext.isSuperAdmin / firestore.rules
// isBootstrapAdmin). Nunca derive super admin de um campo do Firestore.
//
// Escopo do clinicAdmin (NUNCA tem):
//   - acesso a dados de outra clínica (estabelecimentoId != o seu)
//   - poder de conceder/alterar assinatura (subscriptionStatus/accessExpiresAt)
//   - poder de alterar role ou estabelecimentoId de qualquer usuário
//   - rota /super/* (inexistente); usa apenas /admin/*

export const ROLE = {
  CLINIC_ADMIN: 'clinicAdmin',
  PROFESSIONAL: 'professional',
  CLIENT:       'client',
};

// 'admin' é o valor LEGADO de clinicAdmin. Aceito como alias durante a migração
// dos docs existentes em `usuarios`. Remover depois que a migração concluir
// (SeedPage → "Migrar admin → clinicAdmin").
export const LEGACY_ADMIN_ROLE = 'admin';

/** true para clinicAdmin (e o valor legado 'admin'). */
export function isAdminRole(role) {
  return role === ROLE.CLINIC_ADMIN || role === LEGACY_ADMIN_ROLE;
}

/** Roles aceitos na área /admin (inclui o legado durante a transição). */
export const ADMIN_ROLES = [ROLE.CLINIC_ADMIN, LEGACY_ADMIN_ROLE];
